var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ModelManageMenu/ModelManageMenu.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import { Popover, styled } from '@mui/material';
import { combine } from 'effector';
import { useStore } from 'effector-react';
import React from 'react';
import { isNotEmpty } from '@gmini/utils';
import { NotifyButton, Tooltip } from '@gmini/ui-kit';
import { getChildren, getNode, node as serviceNode } from "../../classifier-service";
import { MenuSection } from "./MenuSection";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function createModelManageMenu(_ref) {
  var currentEntity$ = _ref.currentEntity$,
      classifierService = _ref.classifierService,
      bimFile$ = _ref.bimFile$,
      seoEventHandler = _ref.seoEventHandler;
  var currentDependencies$ = combine({
    ɔ: [{
      nodes: classifierService.nodes$,
      currentEntity: currentEntity$
    }, function (_ref2) {
      var currentEntity = _ref2.currentEntity,
          nodes = _ref2.nodes;

      if (!(currentEntity !== null && currentEntity !== void 0 && currentEntity.sourceClassifiers)) {
        return null;
      }

      return currentEntity.sourceClassifiers.map(function (ref) {
        return getNode(nodes, ref);
      }).filter(isNotEmpty);
    }],
    config: {
      name: "currentDependencies$",
      sid: "9outbi"
    }
  });
  var depsWithModels$ = combine({
    ɔ: [{
      nodes: classifierService.nodes$,
      dependencies: currentDependencies$
    }, function (_ref3) {
      var dependencies = _ref3.dependencies,
          nodes = _ref3.nodes;

      if (!dependencies) {
        return null;
      }

      var depsWithModels = [];
      dependencies.forEach(function (baseCls, idx) {
        if (serviceNode.isBaseClassifierNode(baseCls)) {
          getChildren(nodes, baseCls).map(function (_ref4) {
            var element = _ref4.element;
            return getNode(nodes, element);
          }).filter(isNotEmpty).filter(serviceNode.isBimModelNode).forEach(function (model) {
            depsWithModels.push({
              model: model,
              baseClassifier: baseCls,
              depIndex: idx
            });
          });
        }
      });
      return depsWithModels;
    }],
    config: {
      name: "depsWithModels$",
      sid: "-67ncvj"
    }
  });
  var bimFilesList$ = bimFile$.map(function (state) {
    return Object.values(state).filter(isNotEmpty);
  });
  var models$ = combine({
    ɔ: [{
      depsWithModels: depsWithModels$,
      bimFilesList: bimFilesList$
    }, function (_ref5) {
      var bimFilesList = _ref5.bimFilesList,
          depsWithModels = _ref5.depsWithModels;
      return bimFilesList.filter(function (bimFile) {
        return depsWithModels === null || depsWithModels === void 0 ? void 0 : depsWithModels.some(function (_ref6) {
          var baseClassifier = _ref6.baseClassifier,
              model = _ref6.model;

          if (baseClassifier.id !== bimFile.baseClassifierId) {
            return false;
          }

          if (bimFile.status === 'ImportCompleted') {
            var _model$forgeData;

            return ((_model$forgeData = model.forgeData) === null || _model$forgeData === void 0 ? void 0 : _model$forgeData.forgeVersion) !== bimFile.versionId;
          }

          return true;
        });
      }).map(function (_ref7) {
        var _depsWithModels$find$, _depsWithModels$find;

        var author = _ref7.author,
            status = _ref7.status,
            name = _ref7.name,
            versionName = _ref7.versionName,
            versionId = _ref7.versionId,
            baseClassifierId = _ref7.baseClassifierId,
            uploadDate = _ref7.uploadDate,
            urn = _ref7.urn,
            projectUrn = _ref7.projectUrn;
        return {
          author: author,
          depIndex: (_depsWithModels$find$ = depsWithModels === null || depsWithModels === void 0 ? void 0 : (_depsWithModels$find = depsWithModels.find(function (_ref8) {
            var baseClassifier = _ref8.baseClassifier;
            return baseClassifier.id === baseClassifierId;
          })) === null || _depsWithModels$find === void 0 ? void 0 : _depsWithModels$find.depIndex) !== null && _depsWithModels$find$ !== void 0 ? _depsWithModels$find$ : -1,
          urn: urn,
          status: status,
          title: name,
          versionName: versionName,
          versionId: versionId,
          baseClassifierId: baseClassifierId,
          uploadDate: uploadDate,
          projectUrn: projectUrn
        };
      });
    }],
    config: {
      name: "models$",
      sid: "-wt1uqs"
    }
  });

  var byStatus = function byStatus(status) {
    return function (item) {
      return item.status === status;
    };
  };

  var ModelManageMenu = /*#__PURE__*/React.memo(function (_ref9) {
    var disabled = _ref9.disabled;
    var models = useStore(models$, {
      loc: {
        file: _effectorFileName,
        line: 151,
        column: 19
      },
      name: "ModelManageMenu",
      sid: "ModelManageMenu /src/classifier-editor/ModelManageMenu/ModelManageMenu.tsx [151, 19]"
    });
    var currentEntityData = useStore(currentEntity$, {
      loc: {
        file: _effectorFileName,
        line: 152,
        column: 30
      },
      name: "ModelManageMenu",
      sid: "ModelManageMenu /src/classifier-editor/ModelManageMenu/ModelManageMenu.tsx [152, 30]"
    });

    var _React$useState = React.useState(null),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        anchorEl = _React$useState2[0],
        setAnchorEl = _React$useState2[1];

    var open = Boolean(anchorEl);

    var handleClick = function handleClick(event) {
      setAnchorEl(event.currentTarget);
      seoEventHandler === null || seoEventHandler === void 0 ? void 0 : seoEventHandler();
    };

    var handleClose = function handleClose() {
      setAnchorEl(null);
    };

    var NotImported = models.filter(byStatus('NotImported'));
    var ImportCompleted = models.filter(byStatus('ImportCompleted'));
    var ImportInProgress = models.filter(byStatus('ImportInProgress'));
    var ImportError = models.filter(byStatus('ImportError'));
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        placement: "top",
        title: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F",
        children: /*#__PURE__*/_jsx(NotifyButton, {
          onClick: handleClick,
          selected: open,
          active: !disabled && !!models.length && !open,
          disabled: disabled,
          "data-test-id": "viewAvailableUpdates"
        })
      }), currentEntityData && /*#__PURE__*/_jsx(Popover, {
        open: open,
        anchorEl: anchorEl,
        onClose: handleClose,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        children: /*#__PURE__*/_jsx(PopoverBody, {
          children: models.length ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [ImportCompleted.length > 0 && /*#__PURE__*/_jsx(MenuSection, {
              title: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430",
              color: "#0D9966",
              models: ImportCompleted,
              currentEntityData: currentEntityData
            }), ImportError.length > 0 && /*#__PURE__*/_jsx(MenuSection, {
              title: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438",
              color: "#D9575F",
              models: ImportError,
              currentEntityData: currentEntityData
            }), ImportInProgress.length > 0 && /*#__PURE__*/_jsx(MenuSection, {
              title: "\u0418\u0434\u0435\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
              color: "#4C5ECF",
              models: ImportInProgress,
              currentEntityData: currentEntityData
            }), NotImported.length > 0 && /*#__PURE__*/_jsx(MenuSection, {
              title: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u043D\u043E\u0432\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F",
              color: "#353B60",
              models: NotImported,
              currentEntityData: currentEntityData
            })]
          }) : /*#__PURE__*/_jsx(EmptyBlock, {
            children: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0439"
          })
        })
      })]
    });
  });
  ModelManageMenu.displayName = 'ModelManageMenu';
  return {
    ModelManageMenu: ModelManageMenu
  };
}
var PopoverBody = styled('div')({
  minWidth: '370px',
  paddingRight: '7px'
});
var EmptyBlock = styled('div')({
  padding: '20px 24px',
  color: '#000335',
  fontSize: '14px'
});